module.exports = __webpack_public_path__ + "img/ic_close_24px.80816422.svg";